// extracted by mini-css-extract-plugin
module.exports = {"machineIcon":"MachineIcon_machineIcon__2ibuIClgMlnToh8_lknsiQ","machineImage":"MachineIcon_machineImage__2cvuvggFsjjaY6lu1qsI2d"};